<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container pc-show">
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="logoLink">
        <h1 class="logo">
          <img src="@/assets/img/logo.jpg" alt="成都英华科技有限公司" />
          <img src="@/assets/img/yhlogo2.jpg" alt="成都英华科技有限公司" />
        </h1>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == numIndex ? 'active' : ''"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path" class="navItem">
            <div class="top-name" @click="dorpRepeat">
              {{ item.name }}
            </div>
            <div class="down-name" @click="dorpRepeat">{{ item.name }}</div>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n" @click="dorpIndex(n)">
              <router-link :to="i.path" class="nav-left">
                <div>
                  {{ i.name }}
                </div>
              </router-link>
              <router-link :to="i.path" class="nav-right">
                <div>
                  {{ i.name }}
                </div>
              </router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 详情页面头部导航文字图片/numIndex=0 首页不显示 -->
    <div v-if="show" class="banner text-center pc-show"></div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild phone-show">
      <div class="header-nav-m-logo container">
        <img
          @click="logoLink"
          src="@/assets/img/yhlogo.jpg"
          alt="成都英华科技有限公司"
        />
        <div @click="menuClick" class="menu-img">
          <img
            src="@/assets/img/more.png"
            width="50"
            height="50"
            alt="成都英华科技有限公司"
          />
        </div>
        <van-popup
          v-model="showPopup"
          position="right"
          :style="{ height: '100%', width: '70%' }"
        >
          <div>
            <ul id="menu" class="header-nav-m-wrapper menuClass">
              <router-link
                :class="index == navIndex ? 'active' : ''"
                v-for="(item, index) in navList"
                :key="index"
                :to="item.path"
              >
                <li @click="navYdClick(index, item.name)">
                  {{ item.name }}
                  <i class="underline"></i>
                </li>
              </router-link>
            </ul>
          </div>
        </van-popup>
      </div>
      <!-- 导航栏 -->
      <!-- numIndex=0 首页不显示 -->
      <div class="header-nav-m-menu text-center" v-if="show">
        {{ this.$store.state.nameIndex }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      show: false,
      showPopup: false,
      navIndex: this.$store.state.numIndex ? this.$store.state.numIndex : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "关于我们",
          path: "/software",
          children: [
            {
              name: "企业简介",
              path: "/software/smartTown",
            },
            {
              name: "企业文化",
              path: "/software/bigData",
            },
            {
              name: "资质荣誉",
              path: "/software/honor",
            },
            {
              name: "联系我们",
              path: "/software/address",
            },
          ],
        },

        {
          name: "主营业务",
          path: "/case",
          children: [
            {
              name: "信息系统集成",
              path: "/case/caseOne",
            },
            {
              name: "软件平台开发",
              path: "/case/caseTwo",
            },
            {
              name: "三维数字服务",
              path: "/case/caseThree",
            },
            {
              name: "数据分析应用",
              path: "/case/caseFour",
            },
          ],
        },
        {
          name: "项目案例",
          path: "/Mainbus",
          children: [
            {
              path: "/Mainbus/info",
              name: "信息系统集成",
            },
            {
              path: "/Mainbus/services",
              name: "软件平台开发",
            },
            {
              path: "/Mainbus/three",
              name: "三维数字服务",
            },
            {
              path: "/Mainbus/development",
              name: "数据分析应用",
            },
          ],
        },
        {
          name: "新闻动态",
          path: "/news",
          children: [
            {
              path: "/news/newsCompany",
              name: "企业新闻",
            },
            {
              path: "/news/newsIndustry",
              name: "行业新闻",
            },
          ],
        },
        {
          name: "企业党建",
          path: "/party",
          children: [
            {
              path: "/party/partyDynamic",
              name: "党建动态",
            },
            {
              path: "/party/partyResponsibility",
              name: "社会责任",
            },
          ],
        },
        {
          name: "感知与收获",
          path: "/work",
          children: [],
        },
      ],
      titleName: "",
    };
  },
  watch: {
    $route(to, from) {
      const typeName = to.path;
      if (typeName === "/home") {
        this.show = false;
      } else {
        this.show = true;
      }
      //头部导航
      if (typeName.indexOf("home") > -1) {
        this.$store.commit("SET_NUM_INDEX", 0);
      } else if (typeName.indexOf("software") > -1) {
        this.$store.commit("SET_NUM_INDEX", 1);
      } else if (typeName.indexOf("case") > -1) {
        this.$store.commit("SET_NUM_INDEX", 2);
      } else if (typeName.indexOf("Mainbus") > -1) {
        this.$store.commit("SET_NUM_INDEX", 3);
      } else if (typeName.indexOf("news") > -1) {
        this.$store.commit("SET_NUM_INDEX", 4);
      } else if (typeName.indexOf("party") > -1) {
        this.$store.commit("SET_NUM_INDEX", 5);
      } else if (typeName.indexOf("work") > -1) {
        this.$store.commit("SET_NUM_INDEX", 6);
      }

      // 关于我们
      if (typeName.indexOf("smartTown") > -1) {
        this.$store.commit("SET_DORPINDEX", 0);
      } else if (typeName.indexOf("bigData") > -1) {
        this.$store.commit("SET_DORPINDEX", 1);
      } else if (typeName.indexOf("honor") > -1) {
        this.$store.commit("SET_DORPINDEX", 2);
      } else if (typeName.indexOf("address") > -1) {
        this.$store.commit("SET_DORPINDEX", 3);
      }
      // 主营业务左侧导航下标
      if (typeName.indexOf("caseOne") > -1) {
        this.$store.commit("SET_DORPINDEX", 0);
      } else if (typeName.indexOf("caseTwo") > -1) {
        this.$store.commit("SET_DORPINDEX", 1);
      } else if (typeName.indexOf("caseThree") > -1) {
        this.$store.commit("SET_DORPINDEX", 2);
      } else if (typeName.indexOf("caseFour") > -1) {
        this.$store.commit("SET_DORPINDEX", 3);
      }
      // 项目案例
      if (typeName.indexOf("info") > -1) {
        this.$store.commit("SET_DORPINDEX", 0);
      } else if (typeName.indexOf("development") > -1) {
        this.$store.commit("SET_DORPINDEX", 3);
      } else if (typeName.indexOf("three") > -1) {
        this.$store.commit("SET_DORPINDEX", 2);
      } else if (typeName.indexOf("services") > -1) {
        this.$store.commit("SET_DORPINDEX", 1);
      }
      // 新闻动态
      if (typeName.indexOf("newsCompany") > -1) {
        this.$store.commit("SET_DORPINDEX", 0);
      } else if (typeName.indexOf("newsIndustry") > -1) {
        this.$store.commit("SET_DORPINDEX", 1);
      }
      // 企业党建
      if (typeName.indexOf("partyDynamic") > -1) {
        this.$store.commit("SET_DORPINDEX", 0);
      } else if (typeName.indexOf("partyResponsibility") > -1) {
        this.$store.commit("SET_DORPINDEX", 1);
      }

      // 企业党建
      if (typeName.indexOf("workList") > -1) {
        this.$store.commit("SET_DORPINDEX", 0);
      }
    },
  },
  computed: {
    numIndex() {
      return this.$store.state.numIndex;
    },
    nameIndex() {
      return this.$store.state.nameIndex;
    },
  },
  mounted() {
    //出发vuex状态管理
    const getItem = sessionStorage.getItem("navIndex");
    this.$store.commit("SET_NUM_INDEX", getItem);
  },
  methods: {
    logoLink() {
      this.$router.push({
        path: "/",
      });
      this.$store.commit("SET_NUM_INDEX", 0);
    },
    navClick(index, name) {
      // 储存sessionStorage
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      // this.$store.commit('SET_DORPINDEX', '0')
      // sessionStorage.setItem('dropIndex',0)
      this.menuName = name;
      // 保存状态管理vuex
      this.$store.commit("SET_NUM_INDEX", index);
    },
    navYdClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.$store.commit("SET_DORPINDEX", "0");
      // sessionStorage.setItem('dropIndex',0)
      this.menuName = name;
      // 保存状态管理vuex
      this.$store.commit("SET_NUM_INDEX", index);
      this.showPopup = false;
      //导航下拉
      // if (this.menuClass == "glyphicon glyphicon-menu-down") {
      //   this.menuClass = "glyphicon glyphicon-menu-up";
      // } else {
      //   this.menuClass = "glyphicon glyphicon-menu-down";
      // }
    },
    menuClick() {
      this.showPopup = true;
      // if (this.menuClass == "glyphicon glyphicon-menu-down") {
      //   this.menuClass = "glyphicon glyphicon-menu-up";
      //   //禁止页面滚动
      //   document.body.style.overflow = "hidden";
      // } else {
      //   this.menuClass = "glyphicon glyphicon-menu-down";
      //   //出现滚动条
      //   document.body.style.overflow = "";
      // }
    },
    //关闭导航下拉框
    closeNav() {
      this.menuClass = "glyphicon glyphicon-menu-down";
      document.body.style.overflow = "";
    },
    dorpIndex(e) {
      sessionStorage.setItem("dropIndex", e);
      this.$store.commit("SET_DORPINDEX", e);
    },
    dorpRepeat() {
      this.$store.commit("SET_DORPINDEX", 0);
      sessionStorage.setItem("dropIndex", 0);
    },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  /* position: fixed; */
  top: 0;
  left: 0;
  right: 0;
  /* z-index: 9999; */
  width: 100%;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #ca8715;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 77px;
  padding: 0;
}
.pc-show {
  display: block;
}
.phone-show {
  display: none;
  /* position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background: #fff;
  z-index: 99; */
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 300px;
  height: 100%;
  float: left;
  position: relative;
  cursor: pointer;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img:nth-child(1) {
  width: 121px;
  height: 75px;
  /* height: 77px; */
  position: absolute;
  top: 0;
  left: 0;
  right: 400px;
  bottom: 0;
  margin: auto 0;
}
#header .header-nav .header-nav-logo img:nth-child(2) {
  width: 240px;
  height: 75px;
  /* height: 77px; */
  position: absolute;
  top: 0;
  left: 85px;
  right: 0;
  bottom: 0;
  margin: auto 0;
  z-index: 999;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 77px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  /* margin: 0 15px; */
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 18px;
  /* font-weight: bold; */
  /* padding: 15px 0; */
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #ff9600;
  text-decoration: none;
  /* border-bottom: 2px solid #1e73be; */
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  opacity: 0;
  position: absolute;
  width: 100%;
  left: 0;
  background-color: #eee;
  overflow: hidden;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  /* border-bottom: 1px solid #8e8d8d; */
  text-align: center;
  font-size: 15px;
}
#header .header-nav .header-nav-wrapper > li > dl > dt a {
  color: #333;
  text-decoration: none;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover a {
  color: #fff;
  text-decoration: none;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  /* transition: all .8s; */
  opacity: 1;
  z-index: 999999999;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  /* background: #ccc; */
}
@media screen and (max-width: 1024px) {
  #header .header-nav-m {
    /* position: relative; */
  }
  .pc-show {
    display: none;
  }
  .phone-show {
    display: block;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    /* height: 70px; */
    /* position: relative;
    display: flex;
    align-items: center; */
    width: 100%;
    line-height: 60px;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo > img {
    width: 250px;
    /* height: 70px; */
    /* position: absolute;
    top: 0;
    left: 3px;
    right: 0;
    bottom: 0; */
    /* margin: auto; */
  }
  .logo-img {
    padding: 0px 3px;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    background: #1c35b3eb;
    position: relative;
    border-bottom: 1px solid #d9edf7;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  #header .header-nav-m .menu-img {
    float: right;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    /* position: fixed;
    top: 0px;
    left: 0;
    width: 100%;
    background: #01060b52;
    z-index: 9999999;
    text-align: center;
    height: 100%; */
    text-align: center;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > a {
    /* height: 60px; */
    line-height: 60px;
    border-bottom: 1px solid #ccc;
    background: #1a578b;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > a > li {
    color: #fff;
    font-size: 16px;
    background: #2f3973;
    position: relative;
    border-bottom: 1px solid #ccc;
    letter-spacing: 2px;
    font-weight: 600;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > a > li > span {
    font-size: 10px;
  }
  #header .header-nav .header-nav-logo {
    width: 230px;
    height: 100%;
    float: left;
    position: relative;
  }
  #header .header-nav .header-nav-wrapper > li {
    float: left;
    /* margin: 0 11px; */
    position: relative;
  }
}

/* 最新导航css */
#header .header-nav {
  position: relative;
}
#header .header-nav .header-nav-wrapper {
  position: absolute;
  right: 0;
}
#header .header-nav .header-nav-wrapper li {
  margin-top: -77px;
  transition: all 0.2s;
  -webkit-transition: all 0.2s; /* Safari */
}
#header .header-nav .header-nav-wrapper li:hover {
  margin-top: 0px;
  transition: all 0.2s;
  -webkit-transition: all 0.2s; /* Safari */
}
#header .header-nav .header-nav-wrapper li:hover .down-name {
  /* display: none; */
  /* opacity: 0; */
  z-index: -99;
}
#header .header-nav .header-nav-wrapper .top-name,
.down-name {
  padding: 0px 21px;
  font-weight: 600;
  font-size: 15px;
}
#header .header-nav .header-nav-wrapper .top-name {
  color: #fff;
  /* background-color: #ff9600; */
  background-image: url("../assets/img/nav1.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
  background-position: center center;
}
#header .header-nav .header-nav-wrapper li:hover dl {
  margin-top: -77px;
  transition: all 0.2s;
  -webkit-transition: all 0.2s; /* Safari */
}
#header .header-nav .header-nav-wrapper > li > dl > dt {
  display: flex;
  position: relative;
  margin-left: -102px;
  transition: all 0.2s;
  -webkit-transition: all 0.2s; /* Safari */
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  margin-left: 0px;
  transition: all 0.2s;
  -webkit-transition: all 0.2; /* Safari */
}
#header .header-nav .header-nav-wrapper dl .nav-left {
  white-space: nowrap;
  padding: 15px 0px;
  background-image: url("../assets/img/nav1.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
  background-position: center center;
}
#header .header-nav .header-nav-wrapper dl .nav-left a {
  color: #fff;
}
#header .header-nav .header-nav-wrapper dl .nav-right {
  white-space: nowrap;
  padding: 15px 0px;
  background: #eee;
}
#header .header-nav .header-nav-wrapper dl .nav-left div {
  font-weight: 600 !important;
  width: 102px;
}
#header .header-nav .header-nav-wrapper dl .nav-right div {
  font-weight: 600 !important;
  width: 102px;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .menu-img img {
    width: 35px;
    height: 35px;
    right: 5px;
  }
  #header .header-nav-m .header-nav-m-logo > img {
    width: 230px;
    /* height: 60px; */
  }
  #header .header-nav-m .header-nav-m-logo {
    height: 60px;
  }
  #header .header-nav-m .header-nav-m-wrapper {
    top: 0;
  }
}
.banner {
  position: relative;
  color: #fff;
  font-size: 30px;
  height: 300px;
  line-height: 250px;

  /* background-size: 100% 100%;
  background-attachment: scroll;
  background-position: center center; 
  width:100%; */
  background-image: url("../assets/img/city2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue